import { Button, TextInput } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { updateUser } from "../apis/userApis";
import { getCookiesSession, setCookiesSession } from "../apis/cookiesSession";

// Self-service profile screen (proposal step 1 of WhatsApp Evidence Capture:
// "user opens their profile and links their WhatsApp number").
const MyProfile = () => {
  const storedUser = JSON.parse(getCookiesSession("userData") || "{}");
  const [phone, setPhone] = useState(storedUser.phone || "");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const savePhone = async () => {
    const digitsOnly = phone.replace(/\D/g, "");
    if (digitsOnly && digitsOnly.length < 10) {
      setError("Enter a valid WhatsApp number, including country code.");
      return;
    }
    setError("");
    setSaving(true);
    try {
      const response = await updateUser({
        userData: { ...storedUser, phone: digitsOnly },
      });
      if (response.success) {
        const updatedUser = { ...storedUser, phone: digitsOnly };
        setCookiesSession("userData", JSON.stringify(updatedUser), 2);
        setPhone(digitsOnly);
        showNotification({
          color: "green",
          title: "Profile updated",
          message: "Your WhatsApp number has been linked.",
        });
      } else {
        showNotification({
          color: "red",
          title: "Update failed",
          message: response.error || "Please try again.",
        });
      }
    } catch (e) {
      showNotification({
        color: "red",
        title: "Update failed",
        message: "Please try again.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="grid grid-cols-2 m-4 gap-4" style={{ maxWidth: 600 }}>
      <TextInput label="Name" value={storedUser.name || ""} disabled />
      <TextInput label="Email" value={storedUser.email || ""} disabled />
      <TextInput
        label="WhatsApp Number"
        placeholder="e.g. 919876543210"
        description="Include country code, no spaces or symbols. Used to submit evidence via WhatsApp."
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        error={error}
      />
      <div className="flex items-end">
        <Button onClick={savePhone} loading={saving}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default MyProfile;
